/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ant-reset-private/blob/master/LICENSE
 */

import Calendar from './calendar/is_IS';
import DatePicker from './date-picker/is_IS';
import Pagination from './pagination/is_IS';
import TimePicker from './time-picker/is_IS';

export default {
  locale: 'is',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  Table: {
    filterTitle: 'Afmarkanir',
    filterConfirm: 'StaÃ°festa',
    filterReset: 'NÃºllstilla',
    selectAll: 'Velja allt',
    selectInvert: 'ViÃ°snÃºa vali'
  },
  Modal: {
    okText: 'Ãfram',
    cancelText: 'HÃ¦tta viÃ°',
    justOkText: 'Ã lagi'
  },
  Popconfirm: {
    okText: 'Ãfram',
    cancelText: 'HÃ¦tta viÃ°'
  },
  Transfer: {
    searchPlaceholder: 'Leita hÃ©r',
    itemUnit: 'fÃ¦rsla',
    itemsUnit: 'fÃ¦rslur'
  },
  Upload: {
    uploading: 'HleÃ° upp...',
    removeFile: 'FjarlÃ¦gja skrÃ¡',
    uploadError: 'Villa viÃ° aÃ° hlaÃ°a upp',
    previewFile: 'ForskoÃ°a skrÃ¡'
  },
  Empty: {
    description: 'Engin gÃ¶gn'
  }
};
